﻿
(function ($: any) {

    function parseDate(value: string): Date | null {
        if (!value) return null;

        const date = new Date(value + "T00:00:00");
        return isNaN(date.getTime()) ? null : date;
    }

    function today(): Date {
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
    }
       
    $.validator.addMethod("dategreaterthantoday", function (
        value: string,
        element: HTMLElement,
        params: any
    ): boolean {
        

        if (!value) return true;

        const date = parseDate(value);
        if (!date) return true;

        const isValid =
            params.allowtoday === true || params.allowtoday === "true"
                ? date >= today()
                : date > today();

        if (isValid) return true;
 
        return false; // vraie erreur
    });

    $.validator.unobtrusive.adapters.add("dategreaterthantoday", ["allowtoday"], function (options: any) {
        options.rules["dategreaterthantoday"] = {
            allowtoday: options.params.allowtoday
        };

        options.messages["dategreaterthantoday"] = options.message;
    });

})(jQuery);